module.exports = __webpack_public_path__ + "media/images/bottom-background-light-e64d338b.svg";